import styled from "styled-components";

export const StyledDrawingArea = styled.div`
  height: 100%;
  border: 1px solid grey;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: rgba(255, 255, 255, 0.075);
  position: relative;
`;

export const HelpMessage = styled.h1`
  color: white;
  left: 50%;
  font-size: 40px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -100%);
  text-align: center;
  text-shadow: 0 0 80px rgb(192 219 255 / 48%), 0 0 32px rgb(65 120 255 / 24%);
  animation: blinking 2s linear infinite;

  @keyframes blinking {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`;
